import { defineStore } from 'pinia';
import Delta from 'quill-delta';

// Estado partilhado do rascunho da resposta aberta (texto) quando o editor
// está no body e o botão de enviar fica no footer - body e footer são
// componentes irmãos (não há relação pai-filho), por isso partilham aqui
// o conteúdo em vez de o passar por props/emit.
interface IOpenAnswerDraftState {
    content: Delta | null;
}

const useOpenAnswerDraftStore = defineStore({
    id: 'WksOpenAnswerDraft',
    state: (): IOpenAnswerDraftState => ({ content: null }),
    getters: {
        hasContent: (state) => !!(state.content && state.content.ops.length > 0),
    },
    actions: {
        setContent(content: Delta | null) {
            this.content = content;
        },
        clear() {
            this.content = null;
        },
    },
});

export { useOpenAnswerDraftStore };
